import React from "react";
import { useLayoutEffect } from "react";
import { Link } from "react-router-dom";

export default function HeaderHomePage({ onOpen }) {
  useLayoutEffect(() => {
    window.addEventListener("scroll", (e) => {
      const headerMobile = document.querySelector(".header-mobile");

      if (e.currentTarget.scrollY >= e.currentTarget.screen.height / 4) {
        headerMobile.classList.add("bg-gray");
      } else {
        headerMobile.classList.remove("bg-gray");
      }

      const bannerSection = document.querySelector(".banner");
      if (bannerSection) {
        if (bannerSection.getBoundingClientRect().top < 100) {
          headerMobile.classList.add("hide");
        } else {
          headerMobile.classList.remove("hide");
        }
      }
    });

    const menuBtns = document.querySelectorAll(".menu__link");

    if (menuBtns.length) {
      const body = document.querySelector("body");
      const mobileHeader = document.querySelector(".header-mobile");

      menuBtns.forEach((btn) => {
        const link = btn.dataset.block;

        if (link) {
          btn.addEventListener("click", () => {
            const linkBlock = document.querySelector(link);
            const blockTopPosition = linkBlock.getBoundingClientRect().top - 88;

            setTimeout(() => {
              mobileHeader.classList.remove("open");
              body.classList.remove("no-scroll");
              window.scrollBy({
                behavior: "smooth",
                top: blockTopPosition,
              });
            }, 200);
          });
        }
      });
    }
  });

  function openMenu() {
    const body = document.querySelector("body");
    const mobileHeader = document.querySelector(".header-mobile");
    if (mobileHeader.classList.contains("open")) {
      mobileHeader.classList.remove("open");
      body.classList.remove("no-scroll");
    } else {
      mobileHeader.classList.add("open");
      body.classList.add("no-scroll");
    }
  }

  function scrollToTop() {
    const body = document.querySelector("body");
    const mobileHeader = document.querySelector(".header-mobile");
    mobileHeader.classList.remove("open");
    body.classList.remove("no-scroll");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function closeMenu() {
    document.querySelector(".header-mobile").classList.remove("open");
    document.querySelector("body").classList.remove("no-scroll");
  }

  return (
    <header className="header-mobile">
      <div className="header-mobile__block">
        <div className="container">
          <div className="header-mobile__box">
            <div className="header-mobile__logo" onClick={scrollToTop}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="180"
                height="39"
                viewBox="0 0 180 39"
                fill="none"
              >
                <g clipPath="url(#clip0_3849_3776)">
                  <path
                    d="M178.158 3.49733V3.49463H176.704V3.49733H174.863V4.90274H176.704V10.5217H178.158V4.90274H179.998V3.49733H178.158Z"
                    fill="white"
                  />
                  <path
                    d="M172.973 3.49733V4.90274V10.5217H174.324V4.90274V3.49733V3.49463H172.973V3.49733Z"
                    fill="white"
                  />
                  <path
                    d="M50.2541 12.4567C48.327 11.1648 45.9811 10.5216 43.2216 10.5216C40.6108 10.5216 38.3135 11.1135 36.327 12.2973C34.3405 13.4811 32.7892 15.1459 31.673 17.2892C30.5568 19.4351 30 21.9621 30 24.8703C30 27.5648 30.5703 29.9486 31.7135 32.0216C32.8541 34.0946 34.4432 35.7108 36.4784 36.8784C38.5135 38.0459 40.8784 38.6297 43.5703 38.6297C46.2622 38.6297 48.473 37.9648 50.6 36.6324C52.7243 35.3027 54.2973 33.4351 55.3135 31.0351L49.4541 29.2594C48.8784 30.4919 48.0622 31.4351 47.0027 32.0811C45.9432 32.7297 44.6838 33.054 43.2243 33.054C40.9568 33.054 39.2351 32.3162 38.0513 30.8351C37.1243 29.673 36.5622 28.1378 36.3622 26.2243H55.6054C55.8351 23.0378 55.4811 20.2649 54.5459 17.9162C53.6108 15.5649 52.1757 13.7459 50.2486 12.454L50.2541 12.4567ZM36.5054 21.7378C36.7757 20.2 37.2919 18.9459 38.0486 17.9784C39.2297 16.473 41.0351 15.7216 43.4649 15.7216H43.4676C45.6189 15.7216 47.1946 16.3892 48.1946 17.7216C48.9054 18.6649 49.3649 20.0081 49.5811 21.7405H36.5027L36.5054 21.7378Z"
                    fill="white"
                  />
                  <path
                    d="M101.598 10.5216C100.957 10.5216 100.157 10.5351 99.1978 10.5621C98.2384 10.5892 97.3059 10.6973 96.4059 10.8892C94.2411 11.3243 92.4843 12.3108 91.133 13.8567C89.7816 15.4 89.1086 17.4378 89.1086 19.973C89.1086 22.5081 89.8167 24.6 91.2357 26.1C92.2222 27.1432 93.3924 27.9135 94.7411 28.4243L88.3789 38.6297H94.9492L100.752 29.2513C101.101 29.2594 101.419 29.2621 101.701 29.2621H106.714V38.6324H112.974V10.5216H101.598ZM106.714 24.3378H101.055C100.741 24.3378 100.368 24.3216 99.9249 24.2865C99.4843 24.2513 99.0573 24.1811 98.6384 24.0784C97.7897 23.8351 97.0519 23.354 96.4194 22.6351C95.787 21.9135 95.4708 21.0108 95.4708 19.9162C95.4708 19.1865 95.6167 18.5378 95.9113 17.9648C96.2059 17.3919 96.5789 16.9162 97.0303 16.5351C97.4789 16.154 97.9573 15.8865 98.4573 15.727C98.9249 15.6054 99.3924 15.527 99.8573 15.4919C100.325 15.4567 100.722 15.4405 101.052 15.4405H106.711V24.3405L106.714 24.3378Z"
                    fill="white"
                  />
                  <path
                    d="M21.6676 33.0595H5.64054V16.1325H21.6676V10.4919H5.64054L0 16.1325V33.0595L5.64054 38.7001H27.3081V33.0595V16.1325H21.6676V33.0595Z"
                    fill="white"
                  />
                  <path d="M27.3085 0H21.668V10.4919H27.3085V0Z" fill="white" />
                  <path
                    d="M132.146 10.5216H126.506V10.5405H115.676V16.1567H126.506V38.6297H132.146V16.1567H142.973V10.5405H132.146V10.5216Z"
                    fill="white"
                  />
                  <path
                    d="M167.341 18.9486H167.335H151.314V10.5216H145.676V18.954H151.314V24.5703H167.335V33.0081H151.314V24.5757H145.676V33.0081V38.6297H167.335L172.973 33.0081V24.5757L167.335 18.954L167.341 18.9486Z"
                    fill="white"
                  />
                  <path
                    d="M69.719 38.6162L69.7136 38.6189H74.4352L80.0838 32.9702V32.9675H64.0703L69.719 38.6162Z"
                    fill="white"
                  />
                  <path
                    d="M80.0859 32.9676L85.74 27.3135V10.3459H80.0859V32.9676Z"
                    fill="white"
                  />
                  <path
                    d="M58.418 27.3135L62.8774 31.7757V31.773L64.0693 32.9649V10.3459H58.418V27.3135Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3849_3776">
                    <rect width="180" height="38.7" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <button className="open-menu-btn" onClick={openMenu}>
              <svg
                className="open-menu-btn__open"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" fill="#101828" />
                <circle
                  cx="16.194"
                  cy="19.6191"
                  r="0.833333"
                  transform="rotate(90 16.194 19.6191)"
                  fill="white"
                />
                <circle
                  cx="23.8568"
                  cy="15.0237"
                  r="0.833333"
                  transform="rotate(-90 23.8568 15.0237)"
                  fill="white"
                />
                <circle
                  cx="19.0247"
                  cy="19.5953"
                  r="0.666667"
                  transform="rotate(90 19.0247 19.5953)"
                  fill="white"
                />
                <circle
                  cx="21.0221"
                  cy="15.0477"
                  r="0.666667"
                  transform="rotate(-90 21.0221 15.0477)"
                  fill="white"
                />
                <circle
                  cx="21.6888"
                  cy="19.5953"
                  r="0.666667"
                  transform="rotate(90 21.6888 19.5953)"
                  fill="white"
                />
                <circle
                  cx="18.3581"
                  cy="15.0477"
                  r="0.666667"
                  transform="rotate(-90 18.3581 15.0477)"
                  fill="white"
                />
                <circle
                  cx="24.5273"
                  cy="19.6427"
                  r="0.5"
                  transform="rotate(90 24.5273 19.6427)"
                  fill="white"
                />
                <circle
                  cx="15.5234"
                  cy="15"
                  r="0.5"
                  transform="rotate(-90 15.5234 15)"
                  fill="white"
                />
                <circle
                  cx="27.3581"
                  cy="19.619"
                  r="0.333333"
                  transform="rotate(90 27.3581 19.619)"
                  fill="white"
                />
                <circle
                  cx="12.6888"
                  cy="15.0237"
                  r="0.333333"
                  transform="rotate(-90 12.6888 15.0237)"
                  fill="white"
                />
                <circle
                  cx="13.3555"
                  cy="19.6427"
                  r="1"
                  transform="rotate(90 13.3555 19.6427)"
                  fill="white"
                />
                <circle
                  cx="26.6914"
                  cy="15"
                  r="1"
                  transform="rotate(-90 26.6914 15)"
                  fill="white"
                />
                <circle
                  cx="0.833333"
                  cy="0.833333"
                  r="0.833333"
                  transform="matrix(0 -1 -1 1.31134e-07 17.0234 25.1427)"
                  fill="white"
                />
                <circle
                  cx="0.666667"
                  cy="0.666667"
                  r="0.666667"
                  transform="matrix(0 -1 -1 1.31134e-07 19.6914 25)"
                  fill="white"
                />
                <circle
                  cx="0.666667"
                  cy="0.666667"
                  r="0.666667"
                  transform="matrix(0 -1 -1 1.31134e-07 22.3555 25)"
                  fill="white"
                />
                <circle
                  cx="0.5"
                  cy="0.5"
                  r="0.5"
                  transform="matrix(0 -1 -1 1.31134e-07 25.0234 24.7858)"
                  fill="white"
                />
                <circle
                  cx="0.333333"
                  cy="0.333333"
                  r="0.333333"
                  transform="matrix(0 -1 -1 1.31134e-07 27.6914 24.6427)"
                  fill="white"
                />
                <circle
                  cx="1"
                  cy="1"
                  r="1"
                  transform="matrix(0 -1 -1 1.31134e-07 14.3555 25.2856)"
                  fill="white"
                />
              </svg>
              <svg
                className="open-menu-btn__close"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" fill="#667085" />
                <circle
                  cx="16"
                  cy="16"
                  r="1"
                  transform="rotate(-90 16 16)"
                  fill="white"
                />
                <circle
                  cx="24"
                  cy="16"
                  r="1"
                  transform="rotate(-90 24 16)"
                  fill="white"
                />
                <circle
                  cx="18"
                  cy="18"
                  r="1"
                  transform="rotate(-90 18 18)"
                  fill="white"
                />
                <circle
                  cx="20"
                  cy="20"
                  r="1"
                  transform="rotate(-90 20 20)"
                  fill="white"
                />
                <circle
                  cx="22"
                  cy="18"
                  r="1"
                  transform="rotate(-90 22 18)"
                  fill="white"
                />
                <circle
                  cx="18"
                  cy="22"
                  r="1"
                  transform="rotate(-90 18 22)"
                  fill="white"
                />
                <circle
                  cx="22"
                  cy="22"
                  r="1"
                  transform="rotate(-90 22 22)"
                  fill="white"
                />
                <circle
                  cx="16"
                  cy="24"
                  r="1"
                  transform="rotate(-90 16 24)"
                  fill="white"
                />
                <circle
                  cx="24"
                  cy="24"
                  r="1"
                  transform="rotate(-90 24 24)"
                  fill="white"
                />
                <circle
                  cx="14.5"
                  cy="14.5"
                  r="0.5"
                  transform="rotate(-90 14.5 14.5)"
                  fill="white"
                />
                <circle
                  cx="25.5"
                  cy="14.5"
                  r="0.5"
                  transform="rotate(-90 25.5 14.5)"
                  fill="white"
                />
                <circle
                  cx="25.5"
                  cy="25.5"
                  r="0.5"
                  transform="rotate(-90 25.5 25.5)"
                  fill="white"
                />
                <circle
                  cx="14.5"
                  cy="25.5"
                  r="0.5"
                  transform="rotate(-90 14.5 25.5)"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="menu">
        <div className="container">
          <nav className="menu__nav">
            <ul className="menu__list">
              <li className="menu__item">
                <button className="menu__link" data-block="#about">
                  Мы
                </button>
              </li>
              <li className="menu__item">
                <button className="menu__link" data-block="#cases">
                  Кейсы
                </button>
              </li>
              <li className="menu__item">
                <button className="menu__link" data-block="#work">
                  Как мы работаем
                </button>
              </li>
              <li className="menu__item">
                <button className="menu__link" data-block="#expertise">
                  Экспертиза
                </button>
              </li>
              <li className="menu__item">
                <button className="menu__link" data-block="#when">
                  Когда звать нас
                </button>
              </li>
              <li className="menu__item">
                <button className="menu__link" data-block="#team">
                  Команда
                </button>
              </li>
              <li className="menu__item">
                <button className="menu__link" data-block="#partners">
                  Клиенты
                </button>
              </li>
              <li className="menu__item">
                <Link to="/legal" className="menu__link" onClick={closeMenu}>
                  Сведения о компании
                </Link>
              </li>
            </ul>
          </nav>

          <button className="dark-arrow" onClick={onOpen}>
            <span className="dark-arrow__text">Запустить продукт</span>
            <span className="dark-arrow__arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="12"
                viewBox="0 0 17 12"
                fill="none"
              >
                <circle
                  cx="4"
                  cy="6"
                  r="1"
                  transform="rotate(90 4 6)"
                  fill="white"
                />
                <circle
                  cx="1"
                  cy="6"
                  r="1"
                  transform="rotate(90 1 6)"
                  fill="white"
                />
                <circle
                  cx="7"
                  cy="6"
                  r="1"
                  transform="rotate(90 7 6)"
                  fill="white"
                />
                <circle
                  cx="10"
                  cy="6"
                  r="1"
                  transform="rotate(90 10 6)"
                  fill="white"
                />
                <circle
                  cx="13"
                  cy="6"
                  r="1"
                  transform="rotate(90 13 6)"
                  fill="white"
                />
                <circle
                  cx="16"
                  cy="6"
                  r="1"
                  transform="rotate(90 16 6)"
                  fill="white"
                />
                <circle
                  cx="13"
                  cy="9"
                  r="1"
                  transform="rotate(90 13 9)"
                  fill="white"
                />
                <circle
                  cx="13"
                  cy="3"
                  r="1"
                  transform="rotate(90 13 3)"
                  fill="white"
                />
                <circle
                  cx="10"
                  cy="0.500001"
                  r="0.5"
                  transform="rotate(90 10 0.500001)"
                  fill="white"
                />
                <circle
                  cx="10"
                  cy="11.5"
                  r="0.5"
                  transform="rotate(90 10 11.5)"
                  fill="white"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
